/**
 * Homepage Splide initializers
 * - Main visual: autoplay + loop, perPage=1
 * - Pickup products: manual, perPage=4 (PC) / perPage=2 (SP)
 *
 * Splide is loaded via CDN in `layout/theme.liquid`.
 */

(function initHomeSplides() {
  function getPerPageForPickup() {
    return window.matchMedia('(min-width: 768px)').matches ? 4 : 2;
  }

  function mountMainVisual(root) {
    const el = root.querySelector('[data-home-splide="main-visual"]');
    if (!el || typeof window.Splide === 'undefined') return;
    if (el.dataset.splideMounted === 'true') return;
    el.dataset.splideMounted = 'true';

    const splide = new window.Splide(el, {
      type: 'loop',
      perPage: 1,
      perMove: 1,
      autoplay: true,
      pauseOnHover: true,
      pauseOnFocus: true,
      interval: 4000,
      arrows: false,
      pagination: true,
      speed: 600,
    });

    splide.mount();
  }

  function mountPickup(root) {
    const el = root.querySelector('[data-home-splide="pickup-products"]');
    if (!el || typeof window.Splide === 'undefined') return;
    if (el.dataset.splideMounted === 'true') return;
    el.dataset.splideMounted = 'true';

    let splide = new window.Splide(el, {
      type: 'slide',
      perPage: getPerPageForPickup(),
      perMove: 1,
      gap: '16px',
      arrows: true,
      pagination: false,
      autoplay: false,
      rewind: false,
      speed: 600,
      autoHeight: false,
      breakpoints: {
        767: {
          perPage: 2,
          gap: '12px',
        },
      },
    });

    splide.mount();

    const handleResize = () => {
      const nextPerPage = getPerPageForPickup();
      if (!splide) return;
      // Splide v4 supports dynamic options update via .options assignment
      splide.options = { ...splide.options, perPage: nextPerPage };
    };

    window.addEventListener('resize', handleResize, { passive: true });
  }

  function mountAll() {
    const root = document;
    mountMainVisual(root);
    mountPickup(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountAll);
  } else {
    mountAll();
  }
})();

